import CircleQuestionMarkEmpty from '../../src/legacy/CircleQuestionMarkEmpty';
export default CircleQuestionMarkEmpty;
